<template>
    <div id="login_bg" :style="styleObj">
        <div id="login_cont"></div>
    </div>
</template>

<script>
let mouseX = 0,
    mouseY = 0,
    windowHalfX = window.innerWidth / 2,
    windowHalfY = window.innerHeight / 2,
    SEPARATION = 0,
    // AMOUNTX = 10,
    // AMOUNTY = 10,
    camera,
    scene,
    renderer;

export default {
    props: {
        styleObj: {
            type: Object,
            default: function() {
                return {};
            }
        },
        dotNum: {
            type: Number,
            default: function() {
                return 10;
            }
        },
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {
        SEPARATION = this.dotNum > 100 ? 100 : this.dotNum;
        init();
        animate();
    },
    watch: {},
    methods: {}
}

function init() {
    let container, particle;
    container = document.createElement( 'div' );
    setTimeout(() => {
        var selectorId = document.getElementById("login_cont");
        selectorId.appendChild( container );
    }, 0)
    scene = new THREE.Scene();
    renderer = new THREE.CanvasRenderer({ alpha: true }); // gradient; this can be swapped for WebGLRenderer
    renderer.setSize( window.innerWidth, window.innerHeight );
    container.appendChild( renderer.domElement );
    camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        1,
        10000
    );
    camera.position.z = 100;
    // particles
    let PI2 = Math.PI * 2;
    let material = new THREE.SpriteCanvasMaterial({
        color: 0xffffff,
        program: function ( context ) {
                context.beginPath();
        context.arc( 0, 0, 0.5, 0, PI2, true );
        context.fill();
        }
    });
    let geometry = new THREE.Geometry();
    for ( let i = 0; i < SEPARATION; i ++ ) {
        particle = new THREE.Sprite( material );
        particle.position.x = Math.random() * 2 - 1;
        particle.position.y = Math.random() * 2 - 1;
        particle.position.z = Math.random() * 2 - 1;
        particle.position.normalize();
        particle.position.multiplyScalar( Math.random() * 10 + 450 );
        particle.scale.x = particle.scale.y = 10;
        scene.add( particle );
        geometry.vertices.push( particle.position );
    }
    // lines
    let line = new THREE.Line( geometry, new THREE.LineBasicMaterial( { color: 0xffffff, opacity: 0.5 } ) );
    scene.add( line );
    // mousey
    document.addEventListener( 'mousemove', onDocumentMouseMove, false );
        document.addEventListener( 'touchstart', onDocumentTouchStart, false );
    document.addEventListener( 'touchmove', onDocumentTouchMove, false );
        window.addEventListener( 'resize', onWindowResize, false );
}

function onWindowResize() {
    windowHalfX = window.innerWidth / 2;
    windowHalfY = window.innerHeight / 2;
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize( window.innerWidth, window.innerHeight );
}

function onDocumentMouseMove(event) {
    mouseX = event.clientX - windowHalfX;
    mouseY = event.clientY - windowHalfY;
}

function onDocumentTouchStart( event ) {
    if ( event.touches.length > 1 ) {
        event.preventDefault();
        mouseX = event.touches[ 0 ].pageX - windowHalfX;
        mouseY = event.touches[ 0 ].pageY - windowHalfY;
    }
}

function onDocumentTouchMove( event ) {
    if ( event.touches.length == 1 ) {
        event.preventDefault();
        mouseX = event.touches[ 0 ].pageX - windowHalfX;
        mouseY = event.touches[ 0 ].pageY - windowHalfY;
    }
}

function animate() {
    requestAnimationFrame( animate );
    render();
}

function render() {
    camera.position.x += ( mouseX - camera.position.x ) * .05;
    camera.position.y += ( - mouseY + 200 - camera.position.y ) * .05;
    camera.lookAt( scene.position );
    renderer.render( scene, camera );
}
</script>

<style scoped>
/* gradient fallbacks taken from csstricks.com */
#login_cont {
  background-color: #f34523;
  
  /* SVG fallback for IE 9 (could be data URI, or could use filter) */
  /* background-image: url(fallback-gradient.svg); */
  
  /* Safari 4, Chrome 1-9, iOS 3.2-4.3, Android 2.1-3.0 */
  background-image: -webkit-gradient(linear, left top, right top, from(#f34523), to(#ef7a2a));
  
  /* Safari 5.1, iOS 5.0-6.1, Chrome 10-25, Android 4.0-4.3 */
  background-image: -webkit-linear-gradient(left, #f34523, #ef7a2a);
  
  /* Firefox 3.6 - 15 */
  background-image: -moz-linear-gradient(left, #f34523, #ef7a2a);
  
  /* Opera 11.1 - 12 */
  background-image: -o-linear-gradient(left, #f34523, #ef7a2a);
  
  /* Opera 15+, Chrome 25+, IE 10+, Firefox 16+, Safari 6.1+, iOS 7+, Android 4.4+ */
  background-image: linear-gradient(to right, #f34523, #ef7a2a);
  margin: 0px;
  overflow: hidden;
  height: 100%;
  width: 100%;
}
</style>